import { render, staticRenderFns } from "./ylzanghonghua.vue?vue&type=template&id=19aee60b&scoped=true&"
import script from "./ylzanghonghua.vue?vue&type=script&lang=js&"
export * from "./ylzanghonghua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aee60b",
  null
  
)

export default component.exports